import React from "react";

export default function LoginPage() {
    const domain = process.env.REACT_APP_COGNITO_DOMAIN;
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const redirectUri = encodeURIComponent(process.env.REACT_APP_COGNITO_REDIRECT_URI);

    const loginUrl = `https://${domain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=openid+email+profile&redirect_uri=${redirectUri}`;


    return (
        <div style={{ padding: "40px" }}>
        <h2>CloudGenomics Admin Login</h2>
        <p>You must sign in with a CloudGenomics Admin account.</p>

        <button
            onClick={() => (window.location.href = loginUrl)}
            style={{
            padding: "12px 20px",
            fontSize: "16px",
            cursor: "pointer",
            marginTop: "20px"
            }}
        >
            Sign in with CloudGenomics Admin
        </button>
        </div>
    );
}
